import { Component,Output,EventEmitter } from '@angular/core';
import { RouterModule } from '@angular/router';  // Import RouterModule

@Component({
    selector: 'app-header',
    imports: [RouterModule],
    templateUrl: './header.component.html',
    styleUrl: './header.component.css'
})
export class HeaderComponent {
  @Output() headericonSelected = new EventEmitter<string>();
  @Output() isLoginPage = new EventEmitter<boolean>();
  @Output() isRegisterPage = new EventEmitter<boolean>();
  
  onIconClick(iconidentifire: string) {
    this.headericonSelected.emit(iconidentifire);
    
  }
  onLoginClick(LoginPageStatus: boolean) {
    this.isLoginPage.emit(LoginPageStatus);
    
  }
  onRegisterClick(RegisterPageStatus: boolean) {
    this.isRegisterPage.emit(RegisterPageStatus);
    
  }
}
